// Eskom PARCC — CSV/Excel formula-injection neutraliser (pure).
//
// Spreadsheet apps (Excel, Google Sheets, LibreOffice) treat a cell whose first
// character is one of = + - @ — or a leading tab/carriage-return — as a FORMULA.
// So reviewer-entered free text such as `=cmd|' /C calc'!A0` could be evaluated, or
// trigger a DDE prompt, when the exported register/working-paper is opened. This is
// CSV/Excel "formula injection".
//
// The mitigation (OWASP) is to prefix any at-risk value with a single quote so the
// cell can no longer BEGIN with a formula trigger; the apostrophe is a harmless
// text marker. Safe values are returned byte-for-byte unchanged, so this is a no-op
// for controlled-vocabulary cells (statuses, routes, compliance levels, headers) and
// only touches genuinely risky free text. It is applied in the shared column model,
// so both the CSV and the XLSX outputs are covered from one place. Pure — no DOM.

/** A value beginning with one of these is at risk of being parsed as a formula. */
const FORMULA_TRIGGER = /^[=+\-@\t\r]/;

/**
 * Neutralise a single exported cell: if its first character could start a formula,
 * prefix it with a single quote; otherwise return it unchanged. Idempotent — a value
 * already prefixed begins with `'`, which is not a trigger, so re-applying is a no-op.
 */
export function neutraliseCell(value: string): string {
  return FORMULA_TRIGGER.test(value) ? `'${value}` : value;
}
